import { render, staticRenderFns } from "./AddIngredient.vue?vue&type=template&id=3497694f"
import script from "./AddIngredient.vue?vue&type=script&lang=js"
export * from "./AddIngredient.vue?vue&type=script&lang=js"
import style0 from "./AddIngredient.vue?vue&type=style&index=0&id=3497694f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports